import { useEffect, useRef } from 'react';
import { toast } from '@/lib/toast';

/**
 * Runs a one-time health check on mount.
 * If the database is not connected, shows a toast error.
 */
export function useHealthCheck() {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    (async () => {
      try {
        const res = await fetch('/api/health');
        if (res.ok) {
          const data = await res.json();
          if (data.db_connected === false) {
            toast.error('Database connection error');
          }
        }
      } catch {
        // Health check failed silently — server may be starting up
      }
    })();
  }, []);
}
